import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import CreateClientWorkModal from '../../pages/workList/CreateClientWorkModal';
import CreateWorkModal from '../../pages/accountlist/CreateWorkModal';
import HelpModal from '../topbar/HelpModal';
import theme from '../../theme';

const ModalBody = (props) => {
  const {
    editMode,
    isLoading,
    inputErrorMsg,
    setInputErrorMsg,
    modalContent,
    modalData,
    setModalData,
    handleModalSubmit,
    handleClose
  } = props;

  switch (modalContent.render) {
    case 'default':
      return (
        <Box>
          <Typography variant='h4'>{modalContent.content}</Typography>
          {
            modalContent.field &&
            <Typography variant='h5'
              sx={{
                mt: modalData[modalContent.field] ? 2 : 0,
                color: modalContent.mainColor
              }}>
              {modalData[modalContent.field]}
            </Typography>
          }
        </Box>
      )
    case 'createWork':
      return <CreateWorkModal {...props} />
    case 'createClientWork':
      return <CreateClientWorkModal {...props} />
    case 'helpCenter':
      return <HelpModal {...props} />
    default:
      break;
  }
}


export default ModalBody;